var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEffective = function SvgEffective(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2277 21.5638V24C15.6469 23.7588 17.8495 22.794 19.6309 21.3347L17.9218 19.6101C16.5858 20.6472 14.985 21.3467 13.2277 21.5638Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.40722 12C2.40722 7.11557 6.05417 3.06332 10.7723 2.43618V0C4.71816 0.639196 0 5.77688 0 12C0 18.2231 4.71816 23.3608 10.7723 24V21.5638C6.05417 20.9367 2.40722 16.8844 2.40722 12Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5687 10.794H24C23.7593 8.36985 22.7964 6.16282 21.34 4.37789L19.6189 6.10252C20.654 7.42915 21.3521 9.03317 21.5687 10.794Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6309 2.66533C17.8495 1.20603 15.6349 0.241206 13.2277 0V2.43618C14.985 2.65327 16.5858 3.35276 17.9218 4.38995L19.6309 2.66533Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6189 17.9096L21.34 19.6221C22.7964 17.8372 23.7593 15.6302 24 13.206H21.5687C21.3521 14.9668 20.654 16.5709 19.6189 17.9096Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8144 10.9146C16.8144 7.91157 14.5276 5.96986 12 5.96986C9.47239 5.96986 7.18553 7.91157 7.18553 10.9146C7.18553 12.9166 8.78633 15.2925 12 18.0302C15.2136 15.2925 16.8144 12.9166 16.8144 10.9146ZM12 12C11.2898 12 10.7121 11.4211 10.7121 10.7096C10.7121 9.998 11.2898 9.4191 12 9.4191C12.7101 9.4191 13.2878 9.998 13.2878 10.7096C13.2878 11.4211 12.7101 12 12 12Z",
    fill: "currentColor"
  })));
};
export default SvgEffective;